import "./dataviz/gauge/main.js";
import "./kendo.dataviz.themes.js";

export const __meta__ = {
    id: "dataviz.gauge",
    name: "Gauge",
    category: "dataviz",
    description: "Linear, Radial and Arc gauges.",
    depends: [ "dataviz.core", "dataviz.themes" ]
};

export default kendo;